import moment from 'moment';
import { Badge } from 'reactstrap';
import PropTypes from 'prop-types';
import domainModel from 'domain-model';

export default function ArticleBadges({ article }) {
  const {
    isEco,
    promoteAsNewStart,
    promoteAsNewEnd,
    showInNews,
    hasBatchWithShortDate,
    isAvailableForPreorder,
    numberOfExtraDeliveryDays,
  } = article;
  const showArticleAsNews =
    moment().isBetween(promoteAsNewStart, promoteAsNewEnd) && showInNews;

  return (
    <div>
      {showArticleAsNews && (
        <Badge
          color="info"
          className="product-badge product-badge-show-in-news  p-1"
        >
          <span className="product-badge-text fw-normal">Nyhet</span>
        </Badge>
      )}
      {isAvailableForPreorder && (
        <Badge
          color="warning"
          className="product-badge product-badge-large product-badge-prebooking  p-1"
        >
          <span className="product-badge-text fw-normal">Förbokning</span>
        </Badge>
      )}
      {numberOfExtraDeliveryDays && numberOfExtraDeliveryDays > 0 && (
        <Badge
          color="warning"
          className="product-badge product-badge-large product-badge-extra-delivery-days  p-1"
        >
          <span className="product-badge-text fw-normal">
            {numberOfExtraDeliveryDays} extra leveransdagar
          </span>
        </Badge>
      )}
      {domainModel.pricedArticle.hasCampaignWithTheLowestPrice(article) &&
        !hasBatchWithShortDate && (
          <Badge
            color="danger"
            className="product-badge product-badge-campaign  p-1"
          >
            <span className="product-badge-text fw-normal">Kampanj</span>
          </Badge>
        )}
      {domainModel.pricedArticle.hasCampaignWithTheLowestPrice(article) &&
        hasBatchWithShortDate && (
          <Badge
            color="danger"
            className="product-badge product-badge-large product-badge-campaign  p-1"
          >
            <span className="product-badge-text fw-normal">Kort datum</span>
          </Badge>
        )}
      {article.hasLongerDeliveryTime && (
        <Badge
          color="warning"
          className="text-start product-badge product-badge-xlarge product-badge-onDemandArticle  p-1"
        >
          <span className="product-badge-text fw-normal">Beställningsvara</span>
        </Badge>
      )}
      {isEco && (
        <Badge color="success" className="product-badge product-badge-eco  p-1">
          <span className="product-badge-text fw-normal">Ekologisk</span>
        </Badge>
      )}
    </div>
  );
}
ArticleBadges.propTypes = {
  article: PropTypes.object.isRequired,
};
